import { useQuery, UseQueryOptions } from 'react-query';

import { fetchJson } from '@zapier/toolbox-browser-fetch';

import { ZAPIER_APP_BASE_URL } from 'app/common/constants';
import { useNotify } from 'app/developer-v3/hooks';

import { IntegrationVersionConfig } from './types';
import { formatIntegrationVersionConfig } from './utils';

type Args = {
  integrationId: number;
  integrationVersion: string;
};

const QUERY_KEY_PREFIX = 'query-integration-version-config';
const getQueryKey = (args: Args) =>
  `${QUERY_KEY_PREFIX}-${args.integrationId}-${args.integrationVersion}`;

export function formatResponseBody(body: any): IntegrationVersionConfig {
  const integrationVersionConfig = body;
  return formatIntegrationVersionConfig(integrationVersionConfig);
}

function useQueryIntegrationVersionConfig(
  args: Args,
  options?: UseQueryOptions<
    IntegrationVersionConfig,
    Error,
    IntegrationVersionConfig
  >
) {
  const { integrationId, integrationVersion } = args;
  const notify = useNotify();

  const queryKey = getQueryKey({ integrationId, integrationVersion });
  const url = new URL(
    `api/platform/cli/apps/${encodeURIComponent(
      integrationId
    )}/versions/${encodeURIComponent(integrationVersion)}/config`,
    ZAPIER_APP_BASE_URL
  );

  const query = useQuery({
    initialData: {},
    queryKey,
    queryFn: async () => formatResponseBody(await fetchJson(url.href)),
    onError: async (error: any) => {
      if (error?.response?.status === 404) {
        return;
      }
      notify.failure(error.message, queryKey);
    },
    ...options,
  });

  return { ...query, queryKey };
}

export default useQueryIntegrationVersionConfig;
export { getQueryKey, QUERY_KEY_PREFIX };
